/* global */
import Vuex from 'vuex'
import VuexTurbolinks from '../vuex-turbolinks'

// Store imports
import hotel from './modules/hotel'
import packages from './modules/packages'
import orderItem from './modules/order-item'
import event from './modules/event'
import checkout from './modules/checkout'


const plugins = [
  VuexTurbolinks
]

export default new Vuex.Store({
  modules: {
    hotel,
    packages,
    orderItem,
    event,
    checkout
  },

  plugins
})
